import styled from '@emotion/styled';
import { IconScaleStars as IconScaleStarsComponent } from '@presentation/components';

export const IconScaleStars = styled(IconScaleStarsComponent)`
  display: inline-block;
  span {
    cursor: pointer;
    font-size: 20px !important;
  }
`;
